export const REGION_LOADING = 'REGION_LOADING'
export const GET_REGION = 'GET_REGION'
export const CLEAR_REGION = 'CLEAR_REGION'
export const ADD_TO_TEMP_FLEMISH = 'ADD_TO_TEMP_FLEMISH'
export const REMOVE_TEMP_FLEMISH = 'REMOVE_TEMP_FLEMISH'
export const ADD_TO_TEMP_WALLOON = 'ADD_TO_TEMP_WALLOON'
export const REMOVE_TEMP_WALLOON = 'REMOVE_TEMP_WALLOON'
